import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { InstanceStatus, InstanceStatusDTO } from '@iris/common/models/InstanceStatus';
import { API_ENV } from '@iris/common/tokens';
import { EMPTY, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class IrisEnvironmentService {
  private readonly httpClient = inject(HttpClient);
  private readonly _env = inject<IrisEnv>(API_ENV);
  private _backendVersion: string;

  get env(): IrisEnv {
    return this._env;
  }

  set backendVersion(version: string) {
    this._backendVersion = version;
  }

  get backendVersion(): string {
    return this._backendVersion;
  }

  get<T>(field: string): T {
    return this._env[field];
  }

  getInstanceStatus(): Observable<InstanceStatus> {
    return this.httpClient.get<InstanceStatusDTO>(`${this._env.apiUrl}/applicationdetails/status`).pipe(
      map((res: InstanceStatusDTO) => {
        return {
          ...res,
          isProd: res.isProd !== 'false',
        };
      }),
      catchError(() => EMPTY),
    );
  }

}
